import { defineMessages } from 'react-intl';

export default defineMessages({
  email: {
    id: 'login.email',
    defaultMessage: 'Email',
  },
  password: {
    id: 'login.password',
    defaultMessage: 'Password',
  },
  rememberMe: {
    id: 'login.rememberMe',
    defaultMessage: 'remember me',
  },
  forgotPassword: {
    id: 'login.forgotPassword',
    defaultMessage: 'forgot password?',
  },
  signIn: {
    id: 'login.signIn',
    defaultMessage: 'Sign In',
  },
  newTo: {
    id: 'login.newTo',
    defaultMessage: 'New to filespin?',
  },
  createAcc: {
    id: 'login.createAcc',
    defaultMessage: 'Create an account',
  },
  loginFailed: {
    id: 'login.failed',
    defaultMessage: 'Email and password do not match, please try again.',
  },
  loginFailedWithSso: {
    id: 'login.failedWithSso',
    defaultMessage:
      'Email and password do not match, please try again. Signed up with Google or Microsoft? Use those buttons, or set a password via "forgot password".',
  },
  // /login/sso (social login return page)
  ssoSigningIn: {
    id: 'login.sso.signingIn',
    defaultMessage: 'Signing you in…',
  },
  ssoBackToSignIn: {
    id: 'login.sso.backToSignIn',
    defaultMessage: 'Back to sign in',
  },
  ssoContactSales: {
    id: 'login.sso.contactSales',
    defaultMessage: 'Contact sales',
  },
  ssoErrorCancelled: {
    id: 'login.sso.error.cancelled',
    defaultMessage: 'Sign-in was cancelled.',
  },
  ssoErrorExpired: {
    id: 'login.sso.error.expired',
    defaultMessage: 'That sign-in link expired. Please try again.',
  },
  ssoErrorEmailUnverified: {
    id: 'login.sso.error.emailUnverified',
    defaultMessage: 'Your account has no verified email address. Ask your administrator to invite you.',
  },
  ssoErrorAccountDisabled: {
    id: 'login.sso.error.accountDisabled',
    defaultMessage: 'This account is disabled.',
  },
  ssoErrorSignupRejected: {
    id: 'login.sso.error.signupRejected',
    defaultMessage: 'Please sign up with your work account, or contact sales.',
  },
  ssoErrorNoAccount: {
    id: 'login.sso.error.noAccount',
    defaultMessage: 'No FileSpin account is linked to that Google or Microsoft account.',
  },
  ssoCreateAccountLink: {
    id: 'login.sso.error.createAccount',
    defaultMessage: 'Create an account',
  },
  ssoErrorGeneric: {
    id: 'login.sso.error.generic',
    defaultMessage: 'Sign-in failed. Please try again.',
  },
  ssoFinishTitle: {
    id: 'login.sso.finish.title',
    defaultMessage: 'Welcome to {brand}',
  },
  ssoFinishIntro: {
    id: 'login.sso.finish.intro',
    defaultMessage: 'Almost there — tell us who you are and we will set up your workspace.',
  },
  ssoFirstName: {
    id: 'login.sso.finish.firstName',
    defaultMessage: 'First Name',
  },
  ssoLastName: {
    id: 'login.sso.finish.lastName',
    defaultMessage: 'Last Name',
  },
  ssoIndustry: {
    id: 'login.sso.finish.industry',
    defaultMessage: 'Industry',
  },
  ssoCreateAccount: {
    id: 'login.sso.finish.createAccount',
    defaultMessage: 'Create account',
  },
  ssoNameRequired: {
    id: 'login.sso.finish.nameRequired',
    defaultMessage: 'Please enter your first and last name.',
  },
  ssoIndustryRequired: {
    id: 'login.sso.finish.industryRequired',
    defaultMessage: 'Please pick an industry.',
  },
  ssoTermsNote: {
    id: 'login.sso.finish.termsNote',
    defaultMessage: 'By creating an account you agree to our',
  },
});
